import React from 'react';
import { CardContainer, DataContainer } from './styles';
import { Typography, Box } from '@material-ui/core';

const Opinion = ({ image, name, profession, description }) => (
	<CardContainer>
		<Box color={'text.primary'} borderBottom={1} pb={2}>
			<Typography color={'textPrimary'} className="card__description">
				{description}
			</Typography>
		</Box>
		<DataContainer>
			<Typography color={'textPrimary'}>{name}</Typography>
		</DataContainer>
	</CardContainer>
);

export default Opinion;
